export const ru = {
    experimentsArchive: '{experimentsArchiveName} - архив'
};
